import {VendorFilter} from "./filters/vendor.filter";
import {CompanyFilter} from "./filters/company.filter";
import {DynamicFilterDetails, IDynamicFilterFactoryService} from "./dynamic-filter-factory.service.interface";
import {ServiceBase} from "../ServiceBase";

export class DynamicFilterFactoryService extends ServiceBase implements IDynamicFilterFactoryService {
    public createDynamicFilter(dynamicFilter: string): DynamicFilterDetails | null {
        const dynamicFilterPropertiesIndex  = dynamicFilter.indexOf('_');
        if(dynamicFilterPropertiesIndex <= 0) {
            return null;
        }

        const dynamicFilterType = dynamicFilter.slice(0, dynamicFilterPropertiesIndex);
        const dynamicFilterValue = dynamicFilter.slice(dynamicFilterPropertiesIndex + 1, dynamicFilter.length);
        let filterID: string = '';

        switch(dynamicFilterType) {
            case 'vendor':
                let vendorName: string = dynamicFilterValue.toLowerCase();
                filterID = 'vendor_' + vendorName;
                return {
                    gameFilter: new VendorFilter(vendorName),
                    filterID: filterID,
                    activeFilter: {id: filterID, text: "", on: true, isDynamic: true}
                }
            case 'company':
                let companyName: string = dynamicFilterValue.toLowerCase();
                filterID = 'company_' + companyName;
                return {
                    gameFilter: new CompanyFilter(companyName),
                    filterID: filterID,
                    activeFilter: {id: filterID, text: "", on: true, isDynamic: true}
                }
        }

        return null;
    }
}